module.exports = __webpack_public_path__ + "static/media/PushtimargImage49.f8f89b15.jpg";